module.exports = __webpack_public_path__ + "static/img/5.765ea80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/download-new/5.png
// module id = 1Nu5
// module chunks = 3